import { toKebabCase } from "./StringHelper";

export enum AnalysisSetsTableAutomationId {
    SiteNumber,
    SubjectNumber,
    SubjectType,
    VisitName,
    SessionLabel,
    AnalysisSetType,
    CreatedAt,
    StartedAt,
    Overreader,
    Status,
}
export const getAnalysisSetsTableAutomationId = (value: AnalysisSetsTableAutomationId): string => { 
    return toKebabCase(AnalysisSetsTableAutomationId[value]);
}


export enum SessionsTableAutomationId {
    SiteNumber,
    SubjectNumber,
    VisitName,
    SessionLabel,
    SessionType,
    StartedAt,
    TestsCount,
    Technician,
    LastReceived,
    Overreader,
    Status,
}
export const getSessionsTableAutomationId = (value: SessionsTableAutomationId): string => { 
    return toKebabCase(SessionsTableAutomationId[value]);
}

export enum SessionMetadataTableAutomationId {
    StudyName,
    ProtocolNumber,
    SiteNumber,
    SiteName,
    SiteLocation,
    Technician,
    SubjectNumber,
    VisitName,
    SessionName,
    StartedAt,
    Overreader,
    Status,
    Age,
}
export const getSessionMetadataTableAutomationId = (value: SessionMetadataTableAutomationId): string => { 
    return toKebabCase(SessionMetadataTableAutomationId[value]);
}

export enum QueryTableAutomationId {
    Loaded,
    Options,
    Header,
    Column,
    Row,
    FilterMatch,
    FromDate,
    ToDate,
    SubmitFilter,
    ClearAllFilters,
    Modal,
    Sort,
    Filter,
    ViewAnalysis,
    OverreadAnalysis,
    CreateQcBatch,
    QcReview,
    MatchSortHeader,
}
export const getQueryTableAutomationId = (value: QueryTableAutomationId): string => { 
    return toKebabCase(QueryTableAutomationId[value]);
}
